let centerPos = {};
let initialRad = 0;

export const onMouseDown = evt => state => {
  const rect = evt.currentTarget.parentElement.getBoundingClientRect();

  centerPos = {
    x: rect.left + rect.width / 2,
    y: rect.top + rect.height / 2
  };

  initialRad = Math.sqrt(
    Math.pow(evt.clientX - centerPos.x, 2) +
      Math.pow(evt.clientY - centerPos.y, 2)
  );

  state.mouseDown = true;

  return state;
};

export const onMouseMove = evt => state => {
  if (!state.mouseDown) {
    return;
  }

  let activeSticker = state.stickers[state.active];

  state.stickers[state.active] = {
    ...activeSticker,
    scale:
      Math.sqrt(
        Math.pow(evt.clientX - centerPos.x, 2) +
          Math.pow(evt.clientY - centerPos.y, 2)
      ) /
      initialRad *
      activeSticker.prevState.scale,
    rotation: (activeSticker.rotation =
      Math.atan2(evt.clientX - centerPos.x, centerPos.y - evt.clientY) +
      Math.PI / 2)
  };

  return state;
};

export const onMouseUp = evt => state => {
  if (!state.mouseDown) {
    return;
  }

  const activeSticker = state.stickers[state.active];

  state.actions.push({
    type: "EDIT",
    target: state.active,
    prevState: {
      ...activeSticker.prevState,
      scale: activeSticker.prevState.scale,
      rotation: activeSticker.prevState.rotation
    }
  });

  activeSticker.prevState.scale = activeSticker.scale;
  activeSticker.prevState.rotation = activeSticker.rotation;

  state.mouseDown = false;
  return state;
};




// WEBPACK FOOTER //
// ./src/actions/desktop.js